<template>
  <div class="account-dashboard">
    <Header title="Créditos e Premium"></Header>
    <div class="container">
      <div v-if="success">
        <b-alert variant="success" show>
          Muito obrigado por adicionar créditos.
          <br>Eles já estão disponíveis em sua conta.
        </b-alert>
      </div>

      <div class="row">
        <div class="col">
          <b-alert variant="dark" show>
            <h4>premium</h4>

            <div v-if="currentUser && currentUser.is_premium == true">
              <strong>muito obrigado! você é premium :)</strong>
            </div>
            <b-btn
              v-else
              @click.stop.prevent="subscribePremium"
              variant="dark"
            >me tornar premium, R$ 15 por mês</b-btn>
          </b-alert>
        </div>

        <div class="col">
          <b-alert variant="secondary" show>
            <h4>Meu saldo</h4>

            <p class="lead">
              <strong v-html="user.balance"></strong>
            </p>

            <p>Adicione Créditos</p>

            <a
              class="btn btn-info"
              :href="addCreditsUrl"
              v-b-tooltip.hover
              title="você será redicionado para nossa página segura de pagamentos"
            >adicionar créditos</a>
          </b-alert>
        </div>
      </div>

      <div v-if="transactions.length > 0">
        <h5>histórico de transações</h5>

        <div class="stats-table">
          <table class="table is-hoverable is-fullwidth">
            <thead>
              <tr>
                <th>
                  <abbr title>Data</abbr>
                </th>
                <th>
                  <abbr title>Quantia</abbr>
                </th>
                <th>
                  <abbr title>Tipo</abbr>
                </th>
                <th>
                  <abbr title>Descrição</abbr>
                </th>
                <th>
                  <abbr title>Status</abbr>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="transaction in transactions" :key="transaction.id">
                <td>{{ transaction.created_at }}</td>
                <td>{{ transaction.amount }}</td>
                <td v-html="transaction.transaction_type_friendly"></td>
                <td>{{ transaction.description }}</td>
                <td v-html="transaction.transaction_status_friendly"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";

export default {
  name: "AccountDashboard",
  metaInfo: {
    title: "Minha conta"
  },
  data() {
    return {
      success: false,
      transactions: [],
      user: {}
    };
  },
  computed: {
    addCreditsUrl: function() {
      var API_URL =
        window.location.hostname == "queota.club"
          ? "https://api.queota.club"
          : "http://localhost:5000";
      return `${API_URL}/users/${this.$store.getters.user.id}/transactions/new`;
    }
  },
  methods: {
    submit() {},
    subscribePremium() {
      this.$http.post("users/current_user/subscribe.json").then(response => {
        this.$notify({
          group: "all",
          title: "Seja bem-vindo oficialmente ao QUEOTA.club",
          type: "success"
        });

        this.$store.dispatch("updateUserProfile", response.data);
        this.initialize();
      });
    },
    initialize() {
      this.success = window.location.href.indexOf("?success") > 0;

      this.$http.get("pages/my_account.json").then(response => {
        this.user = response.data;
      });

      this.$http
        .get(`users/${this.$store.getters.user.id}/transactions.json`)
        .then(response => {
          this.transactions = response.data;
        });
    }
  },
  mounted() {
    this.initialize();
  },
  components: {
    Header
  }
};
</script>

<style lang="sass" scoped>

</style>
